import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  padded?: boolean;
  interactive?: boolean;
  selected?: boolean;
  dense?: boolean;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, padded = true, interactive = false, selected = false, dense = false, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      data-selected={selected || undefined}
      className={cn(
        'rounded-card border border-border/60 bg-surface shadow-1',
        padded && (dense ? 'p-3' : 'p-4'),
        interactive &&
        'cursor-pointer transition-shadow hover:shadow-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-focus-ring)]',
        selected && 'border-primary bg-primary-soft/10 shadow-sm',
        className,
      )}
      {...props}
    />
  );
});
